import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useSession } from "next-auth/react";
import { useAccountSessionState } from "@shared-utils/hooks/session/session-state-persistener";
import { useM365ApplicationState } from "@ms-teams-poc/utils/hooks/m365cloud";

/**
 * usePersistSessionState
 *
 * Persists the current route as the last visited URL for the authenticated account.
 * Should be used at the top level of the app (e.g., in layout.tsx or _app.tsx).
 */
export function usePersistSessionState() {
  const {
    status
  } = useSession();
  const pathname = usePathname();
  const {
    lastVisitedUrl,
    updateLastVisitedUrl
  } = useAccountSessionState();
  const {
    allowed
  } = useM365ApplicationState();
  useEffect(() => {
    if (!allowed) return;
    if (status !== "authenticated") return;
    if (lastVisitedUrl === pathname) return;
    updateLastVisitedUrl(pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, status, lastVisitedUrl]);
}